import { ref, Ref } from "vue"
import ResponsesCache, { IResponsesCache } from "@/vue/planning/classes/ResponsesCache"

const responsesCache: Ref<IResponsesCache> = ref(new ResponsesCache())

export function reinitResponsesCache(): void {
    responsesCache.value.reinit()
}

export default responsesCache